import { ref } from 'vue'

export const showNextButtonBus = ref(false)
